import { DataObject } from '../../_core/type-converter';
import { BaseAclModel } from '../security/base-acl.model';
import { LeaseAreaModel } from './lease-area.model';

@DataObject()
export class LeaseAreaAclModel extends BaseAclModel {
    public LeaseArea: LeaseAreaModel = new LeaseAreaModel();
}
